import { SubmitHandler } from "react-hook-form";
import { IPlanWizardFormModel } from "../models/planWizardFormModel";
import { PageMode } from "../../../../../common/types";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { routePaths } from "../../../../../common/infrastructure/routes/routePaths";
import { endpointsMetadata } from "../../../../../common/infrastructure/routes/endpointsMetadata";
import { useApiQuery } from "../../../../../common/infrastructure/hooks/useApiQuery";
import { useApiMutation } from "../../../../../common/infrastructure/hooks/useApiMutation";
import { getPlanDurationMetricTypes } from "../../../../../common/utilities/planDurationMetricUtility";
import { usePlanWizardForm } from "./useplanWizardForm";
import { IIPlanWizardInitialDataViewModel } from "../models/planWizardInitialDataViewModel";
import { getPlanConsumerTypes } from "../../../../../common/utilities/planConsumerTypeUtility";

export const usePlanWizardPage = (pageMode: PageMode) => {
  const [isVisitsInputDisabled, setIsVisitsInputDisabled] = useState(false);
  const { mutate: mutate } = useApiMutation();

  const navigate = useNavigate();
  const { id } = useParams();

  const { data: wizardInitialData } =
    useApiQuery<IIPlanWizardInitialDataViewModel>({
      queryKey: [endpointsMetadata.plan.wizardGetInitialData, id],
      endpoint: `${endpointsMetadata.plan.wizardGetInitialData}?planId=${
        id ?? 0
      }`,
    });

  const form = usePlanWizardForm(wizardInitialData);

  const pageTitle = `${
    pageMode === "edit" ? "Редактиране" : "Добавяне"
  } на план`;

  const actionButtonLabel = `${
    pageMode === "edit" ? "Редактиране" : "Добавяне"
  }`;

  const metricOptions = getPlanDurationMetricTypes();
  const consumerTypeOptions = getPlanConsumerTypes();

  const onSave: SubmitHandler<IPlanWizardFormModel> = async (data) => {
    mutate(
      {
        endpoint: endpointsMetadata.plan.wizard,
        globalIsLoading: true,
        method: "post",
        invalidateKeys: [[endpointsMetadata.plan.getAll]],
        ...data,
      },
      {
        onSuccess: () => {
          navigate(routePaths.plans);
        },
      }
    );
  };

  const onCheckboxChange = (isClicked: boolean) => {
    setIsVisitsInputDisabled(isClicked);
  };

  return {
    form,
    pageTitle,
    actionButtonLabel,
    isEdit: pageMode === "edit",
    metricOptions,
    wizardInitialData,
    isVisitsInputDisabled,
    consumerTypeOptions,
    onSave,
    onCheckboxChange,
  };
};
